module.exports = __webpack_public_path__ + "img/qita.544bd697.png";